/**
 * toolMaterialUtils.js
 * Returns a suggested material value based on tool_type.
 * materialMap is the 'values' array from the 'tool_type_material_map'
 * ReferenceData doc — an array of {tool_type, material} objects.
 * Returns the suggested material string, or null if no mapping exists
 * or material is already set.
 *
 * Rule: only suggest if currentMaterial is empty/null. Never overwrite
 * an existing value.
 */
export function getMaterialSuggestion(toolType, currentMaterial, materialMap) {
  if (!toolType || !Array.isArray(materialMap)) return null;
  if (currentMaterial && currentMaterial.trim() !== '') return null;
  const match = materialMap.find(entry => entry.tool_type === toolType);
  return match?.material ?? null;
}
